<script setup lang="ts">
import { useTranslations } from '@/shared/composables/useTranslations';
import { LOW_STOCK_THRESHOLD } from '@/shared/constants/product';

const { t } = useTranslations();
defineProps<{
  inStock: number;
}>();
</script>

<template>
  <span v-if="!inStock" class="font-bold text-error">{{
    t('product.stock.text_oos')
  }}</span>

  <span v-else-if="inStock <= LOW_STOCK_THRESHOLD" class="text-orange">
    {{ t('product.stock.text_low_stock') }}
  </span>
</template>
